import { Avatar, Box, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useTranslation } from 'react-i18next';

const AddCompanionCard = ({ onClick, compact = false }) => {
  const { t } = useTranslation();

  return (
    <Stack
      component="button"
      type="button"
      spacing={compact ? 1 : 1.25}
      alignItems="center"
      onClick={() => onClick?.()}
      aria-label={t('companions.addCard.ariaLabel')}
      sx={{
        width: '100%',
        minHeight: compact ? 126 : 196,
        p: compact ? 1.5 : { xs: 2.5, sm: 3 },
        border: '2px dashed',
        borderColor: 'rgba(15, 76, 69, 0.34)',
        borderRadius: 2,
        bgcolor: 'rgba(255, 250, 240, 0.56)',
        color: 'inherit',
        cursor: 'pointer',
        font: 'inherit',
        textAlign: 'center',
        transition: 'border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease',
        '&:hover, &:focus-visible': {
          borderColor: 'primary.main',
          boxShadow: '0 16px 32px -26px rgba(6, 37, 34, 0.72)',
          transform: 'translateY(-2px)',
        },
        '&:focus-visible': {
          outline: '3px solid',
          outlineColor: 'secondary.light',
          outlineOffset: 4,
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <Avatar
          sx={{
            width: compact ? 58 : 76,
            height: compact ? 58 : 76,
            bgcolor: 'rgba(15, 76, 69, 0.1)',
            color: 'primary.main',
            border: '1px solid rgba(15, 76, 69, 0.18)',
          }}
        >
          <PersonAddAltIcon sx={{ fontSize: compact ? 28 : 36 }} />
        </Avatar>
        <Box
          sx={{
            position: 'absolute',
            right: -4,
            bottom: -4,
            width: compact ? 28 : 34,
            height: compact ? 28 : 34,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            border: '2px solid',
            borderColor: 'background.paper',
            boxShadow: '0 10px 18px -14px rgba(6, 37, 34, 0.82)',
          }}
        >
          <AddIcon sx={{ fontSize: compact ? 18 : 22 }} />
        </Box>
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant={compact ? 'h4' : 'h3'}>
          {t('companions.addCard.title')}
        </Typography>
        {!compact ? (
          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            {t('companions.addCard.subtitle')}
          </Typography>
        ) : null}
      </Box>
    </Stack>
  );
};

export default AddCompanionCard;
